import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { User } from '../services/user';
import { StripeService } from '../services/stripe.service';
import { parse } from 'querystring';




@Component({
  selector: 'app-lista-clientes',
  templateUrl: './lista-clientes.component.html',
  styleUrls: ['./lista-clientes.component.scss']
})
export class ListaClientesComponent implements OnInit {
  public isAdmin: boolean;
  public user: User;
  public clientes: any[];
  public clientesClase: any[];
  public semana: number;
  public year: number;
  public previousYear: number;
  public isCleaningRoutines: boolean = false;


  constructor(private afAuth: AngularFireAuth, private db: AngularFirestore, private stripeService: StripeService) {
    this.clientes = [];
    this.clientesClase = [];
    this.semana = 0;
    this.year = 0;
    this.previousYear = new Date().getFullYear() - 1;
  }

  ngOnInit() {
    this.getSemana();
    this.getClientes();

  }

  private getSemana(): void {
    fetch('https://us-central1-al-fitness.cloudfunctions.net/getDate').then(response => response.json()).then(response => {
      this.semana = parseInt(response.semana);
      this.year = parseInt(response.year);
      this.previousYear = this.year - 1;
      console.log('Server Week: ', response);
      // this.semana = this.getCurrentWeek();
      console.log('Server Week: ', this.semana)
      console.log('Current Week: ', this.getCurrentWeek());
    });
  }

  private getCurrentWeek(): number {
    const now = new Date();
    const start = new Date(now.getFullYear(), 0, 1);
    const diff = now.getTime() - start.getTime();
    const oneDay = 1000 * 60 * 60 * 24;
    const dayOfYear = Math.floor(diff / oneDay);
    const dayOfWeek = start.getDay();
    const weekNum = Math.ceil((dayOfYear + (dayOfWeek === 0 ? 6 : dayOfWeek - 1)) / 7);
    return weekNum;
  }

  public showReactivarPopup: boolean = false;
  public selectedCliente: any = null;

  public reactivar(cliente: any) {
    console.log('Reactivando: ', cliente.email);
    this.selectedCliente = cliente;
    this.showReactivarPopup = true;
  }

  public closeReactivarPopup() {
    this.showReactivarPopup = false;
    this.selectedCliente = null;
  }

  public async onReactivarCliente(reactivationData: any) {
    const { cliente, option, lastInvoice } = reactivationData;
    console.log('Procesando reactivación para: ', cliente.email, 'Opción:', option);

    try {
      switch (option) {
        case 'mark_invoice_paid':
          if (lastInvoice) {
            await this.markInvoiceAsPaid(cliente, lastInvoice);
          } else {
            console.error('No hay factura para marcar como pagada');
          }
          break;
        case 'reactivate_subscription':
          await this.reactivateSubscription(cliente);
          break;
        case 'new_subscription':
          await this.createNewSubscription(cliente);
          break;
        case 'extend_trial':
          await this.extendTrial(cliente);
          break;
        case 'add_credit_balance':
          await this.addCreditBalance(cliente);
          break;
        default:
          console.error('Opción de reactivación no válida:', option);
      }
    } catch (error) {
      console.error('Error durante la reactivación:', error);
      // TODO: Show error notification to user
    } finally {
      this.closeReactivarPopup();
    }
  }

  private async markInvoiceAsPaid(cliente: any, invoice: any) {
    console.log('Marcando factura como pagada:', invoice.id);

    try {
      // Mark the invoice as paid in Stripe
      const result = await this.stripeService.markInvoiceAsPaid(invoice.id);
      console.log('Factura marcada como pagada:', result);

      // Refresh the client list to show updated status
      await this.getClientes();

      // TODO: Show success notification
      alert(`Factura #${invoice.number} marcada como pagada exitosamente`);

    } catch (error) {
      console.error('Error al marcar factura como pagada:', error);
      // TODO: Show error notification
      alert('Error al marcar la factura como pagada. Verifique los logs.');
    }
  }

  private async reactivateSubscription(cliente: any) {
    console.log('Reactivando suscripción para:', cliente.email);
    // TODO: Implement subscription reactivation logic
    alert('Función de reactivación de suscripción en desarrollo');
  }

  private async createNewSubscription(cliente: any) {
    console.log('Creando nueva suscripción para:', cliente.email);
    // TODO: Implement new subscription creation logic
    alert('Función de creación de nueva suscripción en desarrollo');
  }

  private async extendTrial(cliente: any) {
    console.log('Extendiendo período de prueba para:', cliente.email);
    // TODO: Implement trial extension logic
    alert('Función de extensión de período de prueba en desarrollo');
  }

  private async addCreditBalance(cliente: any) {
    console.log('Agregando crédito de $15 para:', cliente.email);

    try {
      // Add $15 credit balance to the customer
      const amount = 1500; // $15.00 in cents
      const description = `Credit balance added - ${cliente.email}`;

      let result;

      try {
        // Try the primary method first
        result = await this.stripeService.addCreditBalance(
          cliente.customer,
          amount,
          'usd',
          description
        );
        console.log('Crédito agregado exitosamente (método principal):', result);
      } catch (primaryError) {
        console.log('Método principal falló, intentando método alternativo:', primaryError);

        // Try the alternative method
        result = await this.stripeService.addCreditBalanceAlternative(
          cliente.customer,
          amount,
          'usd',
          description
        );
        console.log('Crédito agregado exitosamente (método alternativo):', result);
      }

      // Refresh the client list to show updated status
      await this.getClientes();

      // Show success notification
      alert(`Crédito de $15 agregado exitosamente a ${cliente.email}`);

    } catch (error) {
      console.error('Error al agregar crédito (ambos métodos fallaron):', error);
      alert('Error al agregar el crédito. Verifique los logs.');
    }
  }




  async getClientes() {
    this.db.collection('users', ref => ref.orderBy('email')).valueChanges({ idField: 'documentId' }).subscribe(
      async clientes => {
        let promises: any = clientes.map(async (c: any) => {
          c.status = await this.stripeService.getSubscription(c.subscription).then(s => s.status).catch(r => 'test');
          return new Promise((resolve, reject) => { resolve(c) });
        });
        Promise.all(promises).then(
          result => {
            this.clientes = result;
            this.clientes.forEach(cliente => {
              cliente.semana = parseInt(cliente.semana);
              if (cliente.semana == this.semana + 1) {
                cliente.conClase = true;
              } else {
                cliente.conClase = false;
              }
            });
            //console.log('Clientes: ', this.clientes);
          })
      },
      error => {
        console.log(error);
      }
    );
  }

  async eliminarCliente(cliente: any) {
    this.db.collection('users').doc(cliente.documentId).delete().then(() => {
      console.log('customer deleted')
    })
    const xhr = new XMLHttpRequest();
    const data = {
      uid: cliente.documentId
    };
    xhr.open('POST', 'https://us-central1-al-fitness.cloudfunctions.net/deleteAccount');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(JSON.stringify(data));

  }

  public async deleteOld() {
    if (this.isCleaningRoutines) {
      console.log('Cleanup already in progress');
      return;
    }

    this.isCleaningRoutines = true;
    const WEEKS_TO_KEEP = 6;
    console.log("Delete Old: Keeping only the most recent", WEEKS_TO_KEEP, "weeks per user");

    try {

      for (const c of this.clientes) {
        console.log('Processing Cliente: ', c.email);

        try {
          // Get all routines for this user
          const rutinasSnapshot = await this.db.collection('users')
            .doc(c.documentId)
            .collection('rutina')
            .get()
            .toPromise();

          if (!rutinasSnapshot || rutinasSnapshot.empty) {
            console.log('No routines found for', c.email);
            continue;
          }

          // Map routines with their doc references and sortable date value
          const rutinasWithDocs = rutinasSnapshot.docs.map(doc => {
            const data = doc.data();
            const year = parseInt(data.year) || 0;
            const semana = parseInt(data.semana) || 0;
            // Create a sortable value: year * 100 + week (e.g., 202452 for week 52 of 2024)
            const sortValue = year * 100 + semana;
            return {
              docRef: doc.ref,
              year,
              semana,
              sortValue,
              docId: doc.id
            };
          });

          // Sort descending by sortValue (most recent first)
          rutinasWithDocs.sort((a, b) => b.sortValue - a.sortValue);

          // Find unique weeks and determine which to keep
          const uniqueWeeks = new Set<number>();
          const weeksToKeep = new Set<number>();

          for (const rutina of rutinasWithDocs) {
            uniqueWeeks.add(rutina.sortValue);
            if (weeksToKeep.size < WEEKS_TO_KEEP) {
              weeksToKeep.add(rutina.sortValue);
            }
          }

          // Identify routines to delete (those not in the weeks to keep)
          const rutinasToDelete = rutinasWithDocs.filter(r => !weeksToKeep.has(r.sortValue));

          console.log(`${c.email}: Total weeks: ${uniqueWeeks.size}, Keeping: ${weeksToKeep.size}, Deleting: ${rutinasToDelete.length} routines`);

          if (rutinasToDelete.length === 0) {
            console.log('Nothing to delete for', c.email);
            continue;
          }

          // Delete in batches of 500 (Firestore limit)
          const BATCH_SIZE = 500;
          for (let i = 0; i < rutinasToDelete.length; i += BATCH_SIZE) {
            const batchItems = rutinasToDelete.slice(i, i + BATCH_SIZE);
            const batch = this.db.firestore.batch();

            for (const rutina of batchItems) {
              console.log(`Deleting: ${rutina.year}-W${rutina.semana} (${rutina.docId})`);
              batch.delete(rutina.docRef);
            }

            await batch.commit();
            console.log(`Committed batch of ${batchItems.length} deletions for ${c.email}`);
          }

          console.log(`Completed cleanup for ${c.email}`);

        } catch (error) {
          console.error(`Error processing ${c.email}:`, error);
        }
      }

      console.log('Delete Old completed for all clients');
    } finally {
      this.isCleaningRoutines = false;
    }
  }

  public async deleteRepeated() {
    console.log("Delete Repeated");
    // console.log('Clientes: ', this.clientes);
    let numRutinas = 0;
    this.clientes.forEach(c => {
      console.log('Cliente: ', c.email);
      // console.log(c.documentId);
      this.db.collection('users').doc(c.documentId).collection('rutina', ref => ref
        .where('year', "==", '2023')
        .where('semana', "==", '53')
        .where('repetida', "==", true)

      ).get().subscribe(
        async rutinas => {
          let batch = this.db.firestore.batch(); // Create a new batch instance
          rutinas.forEach(doc => {
            console.log('Num Rutinas: ', numRutinas);
            numRutinas++;
            let rutina = doc.data();
            console.log(numRutinas, ' -  Rutina ', rutina.year, ' - ', doc.id, ' - ');

            if (numRutinas < 100) {
              console.log('Borrando: ', rutina.year, ' - ', doc.id, ' - ');
              let docRef = this.db.collection('users').doc(c.documentId).collection('rutina').doc(doc.id).ref;
              batch.delete(docRef); // Add the delete operation to the batch

            } else if (numRutinas % 100 === 0) {
              batch.commit();
              batch = this.db.firestore.batch(); // Create a new batch for the next operations
              numRutinas = 0;
            } else {
              console.log('No se borro nada. Rutinas: ', numRutinas);
            }


          })
          await batch.commit();

        }
      );
    })






  }

}
